import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ResearchProjectsComponent } from './research-projects.component';
const routes: Routes = [
  {
    path: '',
    component: ResearchProjectsComponent
  }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ResearchProjectsRoutingoModule { }